import { Divider } from '@scaleaq/scaleui';

import { responsive } from '@/utils';

export const HeaderDivider = () => (
  <Divider
    color='soft_strong'
    style={{
      marginTop: responsive.spacing.large,
    }}
  />
);
